module.exports = {"content":{},"productInfo":{"code":"{12DEFF98-90DA-4F21-9FCE-7D4B04E04908}","name":"ヘブライ語　初中級","serialHead":"BRNTJ","courseResourceIDs":[{"levelNo":1,"resourceID":"3ef27f7569d16061a79b6f501be6ce43fbac07f5"},{"levelNo":2,"resourceID":"750adb1352df15579bac5b2659fa62ed70835cf4"},{"levelNo":3,"resourceID":"261a771048af2816e95718fc3899bc8698a6d044"}],"language":"he-IL","challengeCount":22014},"version":"1.1.0"}


//////////////////
// WEBPACK FOOTER
// ./static/data.json
// module id = 207
// module chunks = 1